<script>
  import { createEventDispatcher } from 'svelte';

	export let cover
  

  const dispatch = createEventDispatcher();

  function getNew(id) {
    dispatch('message', {
      type: "reload",
      id: id
    });
  }

</script>


  <div class="cover-container">
    <div class="cover" id="{cover.id}" on:click={()=>getNew(cover.id)} style="background-image: url(https://image.tmdb.org/t/p/w154{cover.poster_path})"></div>
  </div>
	


<style>

	.cover {
  height: 0;
  padding-top: 144%;
  position: relative;
  overflow: hidden;

  background-position: center center; 
  background-repeat: no-repeat;
  background-size: cover; 

  border-radius: 0.4rem;
  /*border:  1px solid rgba(127, 127, 127, 1);*/

  transition: transform 0.3s;
  /*box-shadow: 0 0 transparent,0 0 transparent,0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);*/
	}

  .cover:hover {
    transform: scale(0.98);
  }

</style>